const ComponentSet = {
    "r-dialog": () => import("./components/MessageDialog.vue"),
    "r-video-dialog": () => import("./components/VideoDialog.vue"),
    "r-pagination": () => import("./components/Pagination.vue"),
    "r-top": () => import("./components/Top.vue"),
    "r-footer": () => import("./components/Footer.vue"),
    "r-loading": () => import("./components/Loading.vue"),
    index: () => import("./pages/home/Index.vue"),
    search: () => import("./pages/home/Search.vue"),
    "about-index": () => import("./pages/about/AboutIndex.vue"),
    "about-business": () => import("./pages/about/AboutBusiness.vue"),
    "news-list": () => import("./pages/news/NewsList.vue"),
    "news-detail": () => import("./pages/news/NewsDetail.vue"),
    "product-list": () => import("./pages/product/ProductList.vue"),
    "product-detail": () => import("./pages/product/ProductDetail.vue"),
    quote: () => import("./pages/quote/Quote.vue"),
    faq: () => import("./pages/faq/Faq.vue"),
    warranty: () => import("./pages/warranty/Warranty.vue"),
    inquiry: () => import("./pages/quote/Inquiry.vue"),
    catalog: () => import("./pages/catalog/Catalog.vue"),
};

export default ComponentSet;
